// removed by extract-text-webpack-plugin
module.exports = {"blue_btn":"buttons_blue_btn_3Mlr2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Buttons/buttons.css
// module id = 333
// module chunks = 0